import type { SvgIconComponent } from "@mui/icons-material";
import ArticleIcon from "@mui/icons-material/ArticleOutlined";
import VideoIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import type { InvestorCommunicationType } from "../../../api/types/investorCommunicationsTypes";

export const investorCommunicationTypeIcons: Record<InvestorCommunicationType, SvgIconComponent> = {
  Article: ArticleIcon,
  Video: VideoIcon,
};
